import { render, staticRenderFns } from "./ProductVariantSelection.vue?vue&type=template&id=2b99f674"
import script from "./ProductVariantSelection.vue?vue&type=script&lang=js"
export * from "./ProductVariantSelection.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantSelection.vue?vue&type=style&index=0&id=2b99f674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports